/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Device1Inputs */

const zh_accountsettings_device1 = /** @type {(inputs: Accountsettings_Device1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设备`)
};

const en_accountsettings_device1 = /** @type {(inputs: Accountsettings_Device1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Device`)
};

const es_accountsettings_device1 = /** @type {(inputs: Accountsettings_Device1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivo`)
};

/**
* | output |
* | --- |
* | "Device" |
*
* @param {Accountsettings_Device1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_device1 = /** @type {((inputs?: Accountsettings_Device1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Device1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_device1(inputs)
	if (locale === "en") return en_accountsettings_device1(inputs)
	return es_accountsettings_device1(inputs)
});
export { accountsettings_device1 as "accountSettings_device" }